import { Plus } from 'lucide-react'
import { Button, UserList, UserForm, UserFilters } from '../components'
import { useUsers } from '../hooks/useUsers'

function Users() {
  const {
    // State
    searchTerm,
    setSearchTerm,
    currentPage,
    showModal,
    setShowModal,
    editingUser,
    selectedAvatar,
    avatarPreview,
    
    // Data
    users,
    isLoading,
    totalPages,
    totalItems,
    
    // Loading states
    isCreating,
    isUpdating,
    isDeleting,
    isToggling,
    isUploadingAvatar,
    isDeletingAvatar,
    
    // Handlers
    handleSubmit,
    handleEdit,
    handleDelete,
    handleToggleStatus,
    handleCloseModal,
    handleAvatarSelect,
    handleAvatarUpload,
    handleAvatarDelete,
    handleRemoveAvatarPreview,
    handlePageChange,
    handleClearFilters,
  } = useUsers()

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-4xl font-bold text-secondary-900">Users</h1>
          <p className="mt-1 text-base text-secondary-600">
            Manage system users (excluding role ID = 1)
          </p>
        </div>
        <Button
          onClick={() => setShowModal(true)}
          variant="primary"
          size="md"
        >
          <Plus className="h-4 w-4 mr-2" />
          Add User
        </Button>
      </div>

      {/* Filters */}
      <UserFilters
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        onClearFilters={handleClearFilters}
      />

      {/* Users List */}
      <UserList
        users={users}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onToggleStatus={handleToggleStatus}
        onAvatarSelect={handleAvatarSelect}
        onAvatarDelete={handleAvatarDelete}
        isUploadingAvatar={isUploadingAvatar}
        isDeletingAvatar={isDeletingAvatar}
      />

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="card">
          <div className="card-content">
            <div className="flex items-center justify-between">
              <div className="text-sm text-secondary-700">
                Showing {((currentPage - 1) * 10) + 1} to {Math.min(currentPage * 10, totalItems)} of {totalItems} results
              </div>
              <div className="flex items-center space-x-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </Button>
                <span className="text-sm text-secondary-700">
                  Page {currentPage} of {totalPages}
                </span>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* User Form Modal */}
      <UserForm
        isOpen={showModal}
        editingUser={editingUser}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        isLoading={isCreating || isUpdating}
        selectedAvatar={selectedAvatar}
        avatarPreview={avatarPreview}
        onAvatarSelect={(e) => handleAvatarSelect(e)}
        onAvatarUpload={handleAvatarUpload}
        onAvatarDelete={handleAvatarDelete}
        onRemoveAvatarPreview={handleRemoveAvatarPreview}
        isUploadingAvatar={isUploadingAvatar}
      />
    </div>
  )
}

export default Users